import { render } from "./PieChart.vue?vue&type=template&id=4a046182"
import script from "./PieChart.vue?vue&type=script&lang=ts"
export * from "./PieChart.vue?vue&type=script&lang=ts"

import "./PieChart.vue?vue&type=style&index=0&id=4a046182&lang=scss"
script.render = render

export default script